module.exports = __webpack_public_path__ + "static/NRRD-logo-8cc8a5e045934e0aad41e7ecc569b299.svg";